module.exports = __webpack_public_path__ + "img/step.808c3715.png";